import React from "react";

import { useLoading } from "@hooks";
import classNames from "classnames";
import { observer } from "mobx-react";

import { SharedLoaderSpinner } from "../shared";

export default observer(function Loader(props: {
	className?: string;
	isLoading?: boolean;
}) {
	const { isLoading } = useLoading();

	const loaderClasses = classNames("loader loader--full", props.className);

	if (!isLoading && !props?.isLoading) {
		return null;
	}

	return (
		<div className={loaderClasses} data-at="at-defaultLoader">
			<SharedLoaderSpinner />
		</div>
	);
});
